import { Button, Checkbox, Heading, Icon, IconButton, Select, Spinner, Stack, Table, TableContainer, Tbody, Td, Text, Th, Thead, Tr, useToast } from "@chakra-ui/react";
import { useEffect, useState } from "react";


import { BsExclamationLg } from "react-icons/bs";
import { FaArrowLeft, FaArrowRight, FaColumns, FaSync, FaCheck } from "react-icons/fa";
import { GrClose } from "react-icons/gr";
import { RiFolderWarningFill } from "react-icons/ri";
import { SiQuickbooks } from "react-icons/si";
import { GET } from "../../../utils/ApiRequestProvider";

export default function ExportErrors() {
    const toast = useToast();
    const [invs, setInvs] = useState<Array<any>>([]);
    const [loading, setLoading] = useState(false);
    const [paginationQuery, setPaginationQuery] = useState({ page: 1, pageSize: 10 });
    const [pagination, setPagination] = useState({ currentPage: 0, totalPages: 0, totalRecords: 0 });

    const convertDate = (date: string | null) => (date ? new Date(date).toLocaleString() : '');

    async function FetchList() {
        setLoading(true);
        try {
            const res = await GET(`/api/internal/export-errors?page=${paginationQuery.page}&pageSize=${paginationQuery.pageSize}`);
            setInvs(res.data.documents ?? []);
            setPagination(res.data.pagination);
        } catch (err) {
            toast({
                title: 'Something Went Wrong!',
                description: 'An unexpected error occured while proceeding your request!',
                status: 'error', isClosable: false, duration: 1000, position: 'top-right'
            });
        }
        setLoading(false);
    }

    useEffect(() => {
        FetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationQuery]);

    return (
        <Stack w={'full'} justify={"center"} align={"center"} spacing={6}>
            <Stack
                direction={{ base: 'column', md: 'column', lg: 'column', xl: 'row' }}
                justify={'space-between'}
                boxShadow={'base'}
                rounded={'xl'}
                w={'98%'}
                p={4}
                spacing={{ base: 6, md: 6, lg: 6, xl: 0 }}
            >
                <Stack
                    align={'flex-start'}
                    justify={'start'}
                    spacing={4}
                >
                    <Stack direction={'row'}>
                        <Icon
                            as={RiFolderWarningFill}
                            fontSize={'5xl'}
                            color={'primary.400'}
                        />
                        <Stack spacing={1}>
                            <Heading fontSize={'xl'}>Export Errors</Heading>
                            <Text fontSize={'sm'}>Here you can view all your external error messages.</Text>
                        </Stack>
                    </Stack>
                </Stack>
                <Stack
                    spacing={4}
                    justify={'end'}
                    direction={'row'}
                    align={'center'}
                >
                    <Checkbox
                        size={'sm'}
                        colorScheme={'primary'}
                    >
                        Include Exported
                    </Checkbox>

                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'primary.400'}
                        leftIcon={<FaSync />}
                        _hover={{ bg: 'primary.600' }}
                        _active={{ bg: 'primary.800' }}
                    >
                        Refresh
                    </Button>

                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'primary.400'}
                        leftIcon={<FaColumns />}
                        _hover={{ bg: 'primary.600' }}
                        _active={{ bg: 'primary.800' }}
                    >
                        Columns
                    </Button>

                    <Button
                        size={'sm'}
                        color={'white'}
                        bg={'gray.400'}
                        leftIcon={<BsExclamationLg />}
                        _hover={{ bg: 'gray.400' }}
                        _active={{ bg: 'gray.500' }}
                    >
                        Clear Filter
                    </Button>
                </Stack>
            </Stack>

            <Stack boxShadow={'base'} rounded={'xl'} w={'98%'} p={4} spacing={4}>
                <TableContainer h={'sm'} overflowY={'scroll'}>
                    <Table size='sm'>
                        <Thead position={'sticky'} top={'0%'} h={'50px'} bg={'primary.400'} alignItems={'flex-start'} zIndex={1}>
                            <Tr>
                                <Th
                                    isNumeric
                                    color={"white"}
                                >
                                    Org Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Org Owner Email
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Entity Name
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Software
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Doc Status
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    External Error
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    EB Error
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Created On
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    is Exported
                                </Th>
                                <Th
                                    color={'white'}
                                >
                                    Process
                                </Th>
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                invs.length > 0 ? (
                                    invs.map((inv, i) => (
                                        <Tr key={i}>
                                            <Td>{inv.orgName}</Td>
                                            <Td>{inv.orgOwnerEmail}</Td>
                                            <Td>{inv.entityName}</Td>
                                            <Td>{inv.software === 'QuickBooks' ? <SiQuickbooks /> : inv.software}</Td>
                                            <Td>{inv.docStatus}</Td>
                                            <Td w={'250px'}>{inv.externalError}</Td>
                                            <Td>{inv.ebError}</Td>
                                            <Td>{convertDate(inv.createdOn)}</Td>
                                            <Td>{inv.isExported ? <FaCheck color="#38a169" /> : <GrClose color="#f54242" />}</Td>
                                            <Td>
                                                <Button
                                                    w={'full'}
                                                    size={'sm'}
                                                    color={'white'}
                                                    bg={'primary.400'}
                                                    _hover={{ bg: 'primary.400' }}
                                                    _active={{ bg: 'primary.400' }}
                                                >
                                                    Send to Supervisor
                                                </Button>
                                            </Td>
                                        </Tr>
                                    ))
                                ) : (
                                    <Tr>
                                        <Td colSpan={10} textAlign={'center'}>
                                            {loading ? <Spinner size={'sm'} color={'primary.400'} /> : 'No Data Available'}
                                        </Td>
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </TableContainer>
                <Stack
                    direction={'row'}
                    justify={"space-between"}
                    align={'center'}
                >
                    <Text>Showing {invs.length} of {pagination.totalRecords} results</Text>
                    <Stack direction={'row'} spacing={4}>
                        <Select defaultValue={10} onChange={(e) => setPaginationQuery({ page: 1, pageSize: parseInt(e.target.value) })}>
                            <option value={5}>5 Per Page</option>
                            <option value={10}>10 Per Page</option>
                            <option value={25}>25 Per Page</option>
                            <option value={50}>50 Per Page</option>
                        </Select>
                        <Stack direction={'row'}>
                            <IconButton
                                aria-label="Previous"
                                icon={<FaArrowLeft />}
                                rounded={'full'}
                                disabled={pagination.currentPage <= 1}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage - 1 })}
                            />
                            <IconButton
                                aria-label="Next"
                                icon={<FaArrowRight />}
                                rounded={'full'}
                                disabled={pagination.currentPage >= pagination.totalPages}
                                onClick={() => setPaginationQuery({ ...paginationQuery, page: pagination.currentPage + 1 })}
                            />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack >
    )
}